import { render } from "./Modelling.vue?vue&type=template&id=f99a814e&scoped=true"
import script from "./Modelling.vue?vue&type=script&lang=js"
export * from "./Modelling.vue?vue&type=script&lang=js"

import "./Modelling.vue?vue&type=style&index=0&id=f99a814e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f99a814e"]])

export default __exports__